import { createContext, ReactElement, ReactNode, useContext, useMemo } from 'react'

import { useFetchQuote } from '@features/invoices/hooks/useFetchQuote'
import { Quote } from '@features/invoices/types/quotes/quote'

interface ContextState {
  isFetching: boolean
  isLoading: boolean
  quote?: Quote
  quoteId: string
}

const QuoteContext = createContext<ContextState | undefined>(undefined)

interface QuoteContextProps {
  children?: ReactNode
  quoteId: string
}

export const QuoteContextProvider = ({ quoteId, children }: QuoteContextProps): ReactElement => {
  const { quote, isLoading, isFetching } = useFetchQuote(quoteId)

  const contextValue = useMemo(
    () => ({
      isFetching,
      isLoading,
      quote,
      quoteId,
    }),
    [isFetching, isLoading, quote, quoteId],
  )

  return <QuoteContext.Provider value={contextValue}>{children}</QuoteContext.Provider>
}

export const useQuote = () => {
  const context = useContext(QuoteContext)

  if (!context) {
    throw new Error('QuoteContextProvider is missing in the module!')
  }

  return context
}
